/* GOPSHOP – Suche & Filter (sections/main-search.liquid, sections/main-collection-product-grid.liquid, snippets/facets.liquid)
   – Ansicht umschalten (kompakt/groß), gemerkt im Browser (localStorage „gsr-view“)
   – Handy-Filterblatt: Filter klappen direkt auf (statt Unterseiten), „X Produkte anzeigen“ zählt live mit
   – Preis-Schieberegler ↔ Dawn-Preisfelder „Von/Bis“ – gefiltert wird weiter über assets/facets.js (AJAX)
   – Suchseite: letzte Suchbegriffe (localStorage „gsr-recent“, max. 8, löschbar)
   – „Jetzt anfragen“: füllt das Wunschformular vor (sessionStorage „gop-wish-prefill“ → assets/gop-wish.js) */
(function () {
  'use strict';
  if (window.__gopSearch) return;
  window.__gopSearch = true;

  var RECENT_KEY = 'gsr-recent';
  var VIEW_KEY = 'gsr-view';
  var lastFocusId = '';

  function store(kind, fn) {
    try {
      return fn(window[kind]);
    } catch (e) {
      return null;
    }
  }

  function closest(el, sel) {
    return el && el.closest ? el.closest(sel) : null;
  }

  /* ---------- Ansicht kompakt / groß ---------- */
  function syncView(root) {
    var v = root.getAttribute('data-gsr-view') || 'compact';
    root.querySelectorAll('[data-gsr-view-btn]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-gsr-view-btn') === v ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var b = closest(e.target, '[data-gsr-view-btn]');
    if (!b) return;
    var root = closest(b, '.gsr');
    if (!root) return;
    var v = b.getAttribute('data-gsr-view-btn');
    root.setAttribute('data-gsr-view', v);
    syncView(root);
    store('localStorage', function (s) {
      s.setItem(VIEW_KEY, v);
    });
  });

  /* ---------- Handy-Filterblatt: Filter als Aufklapp-Liste ----------
     Dawn (global.js › MenuDrawer) öffnet jeden Filter als eigene Unterseite. Im GOPSHOP-Blatt klappen die
     <details> nativ auf – deshalb erreicht der Klick die Dawn-Logik hier nicht (Capture-Phase, kein preventDefault). */
  document.addEventListener(
    'click',
    function (e) {
      var summary = closest(e.target, 'summary');
      if (!summary) return;
      var details = summary.parentElement;
      if (!details || !details.classList.contains('mobile-facets__details') || !closest(details, '.gsr')) return;
      e.stopPropagation();
      setTimeout(function () {
        summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      });
    },
    true
  );

  /* Zähler am Filter (Handy) sofort anpassen + Fokus nach dem AJAX-Neuzeichnen wiederfinden */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !closest(t, '.gsr')) return;
    var details = closest(t, '.mobile-facets__details');
    if (details) {
      var badge = details.querySelector('[data-gsr-n]');
      if (badge) {
        var n = details.querySelectorAll('input[type="checkbox"]:checked').length;
        badge.textContent = n;
        badge.hidden = !n;
      }
    }
    if (t.id && closest(t, '.mobile-facets')) lastFocusId = t.id;
  });

  /* ---------- Preis-Schieberegler ---------- */
  function paintRange(r) {
    var lo = r.querySelector('[data-gsr-range-lo]');
    var hi = r.querySelector('[data-gsr-range-hi]');
    var max = parseFloat(r.getAttribute('data-max')) || 1;
    if (!lo || !hi) return;
    r.style.setProperty('--gsr-lo', (Math.min(+lo.value, +hi.value) / max) * 100 + '%');
    r.style.setProperty('--gsr-hi', (Math.max(+lo.value, +hi.value) / max) * 100 + '%');
  }

  function priceFields(r) {
    var box = r.parentElement;
    var pr = box ? box.querySelector('price-range') : null;
    return pr ? pr.querySelectorAll('input') : [];
  }

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t) return;
    var r = closest(t, '[data-gsr-range]');
    if (r) {
      var lo = r.querySelector('[data-gsr-range-lo]');
      var hi = r.querySelector('[data-gsr-range-hi]');
      var max = parseFloat(r.getAttribute('data-max')) || 1;
      var a = +lo.value;
      var b = +hi.value;
      if (a > b) {
        if (t === lo) lo.value = a = b;
        else hi.value = b = a;
      }
      paintRange(r);
      var f = priceFields(r);
      if (f.length > 1) {
        f[0].value = a > 0 ? a : '';
        f[1].value = b < max ? b : '';
      }
      return; /* facets.js hört auf „input“ am Formular und filtert nach 0,5 s Pause */
    }
    var pr = closest(t, 'price-range');
    if (pr && pr.parentElement) {
      var range = pr.parentElement.querySelector('[data-gsr-range]');
      if (!range) return;
      var inputs = pr.querySelectorAll('input');
      var m = parseFloat(range.getAttribute('data-max')) || 1;
      var v1 = parseFloat(String(inputs[0].value).replace(',', '.'));
      var v2 = parseFloat(String(inputs[1].value).replace(',', '.'));
      range.querySelector('[data-gsr-range-lo]').value = isNaN(v1) ? 0 : Math.max(0, Math.min(v1, m));
      range.querySelector('[data-gsr-range-hi]').value = isNaN(v2) ? m : Math.max(0, Math.min(v2, m));
      paintRange(range);
    }
  });

  /* ---------- Nach dem AJAX-Filtern (facets.js ersetzt #ProductGridContainer) ---------- */
  function applyLabel(n) {
    document.querySelectorAll('[data-gsr-apply]').forEach(function (el) {
      var tpl = n === 0 ? el.getAttribute('data-zero') : n === 1 ? el.getAttribute('data-one') : el.getAttribute('data-other');
      if (tpl) el.textContent = tpl.replace('{n}', n);
    });
  }

  function afterRender() {
    var total = document.querySelector('#ProductGridContainer [data-gsr-total]');
    if (total) applyLabel(parseInt(total.getAttribute('data-gsr-total'), 10) || 0);
    document.querySelectorAll('.gsr').forEach(syncView);
    if (lastFocusId) {
      var el = document.getElementById(lastFocusId);
      var active = document.activeElement;
      if (el && (!active || active === document.body) && closest(el, 'details[open]')) {
        try {
          el.focus({ preventScroll: true });
        } catch (err) {
          /* ältere Browser */
        }
      }
    }
  }

  /* ---------- Letzte Suchen ---------- */
  function getRecent() {
    var list = store('localStorage', function (s) {
      var a = JSON.parse(s.getItem(RECENT_KEY) || '[]');
      return Array.isArray(a) ? a : [];
    });
    return (list || []).filter(function (x) {
      return typeof x === 'string' && x.trim();
    });
  }

  function addRecent(q) {
    q = String(q || '')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, 60);
    if (!q) return;
    if (window.gopFakeRx && window.gopFakeRx.test(q)) return;
    var list = getRecent().filter(function (x) {
      return x.toLowerCase() !== q.toLowerCase();
    });
    list.unshift(q);
    store('localStorage', function (s) {
      s.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 8)));
    });
  }

  function renderRecent(box) {
    var ul = box.querySelector('[data-gsr-recent-list]');
    if (!ul) return;
    var root = closest(box, '.gsr');
    var current = String((root && root.getAttribute('data-gsr-terms')) || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
    var list = getRecent().filter(function (q) {
      return q.toLowerCase() !== current; /* aktueller Begriff steht schon im Suchfeld */
    });
    var base = box.getAttribute('data-url') || '/search';
    ul.textContent = '';
    list.forEach(function (q) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.className = 'gsr-chip gsr-chip--recent';
      a.href = base + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
      a.textContent = q;
      li.appendChild(a);
      ul.appendChild(li);
    });
    box.hidden = !list.length;
  }

  document.addEventListener('click', function (e) {
    var clear = closest(e.target, '[data-gsr-recent-clear]');
    if (!clear) return;
    store('localStorage', function (s) {
      s.removeItem(RECENT_KEY);
    });
    var box = closest(clear, '[data-gsr-recent]');
    if (box) {
      renderRecent(box);
      var input = document.getElementById('Search-In-Template');
      if (input) input.focus();
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.getAttribute('role') !== 'search') return;
    var input = form.querySelector('input[name="q"]');
    if (input) addRecent(input.value);
  });

  /* ---------- „Jetzt anfragen“ → Wunschformular vorbefüllen ---------- */
  document.addEventListener('click', function (e) {
    var a = closest(e.target, '[data-gsr-wish]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
    var text = (a.getAttribute('data-gsr-wish') || '').trim().slice(0, 120);
    var form = document.querySelector('[data-gop-wish]');
    if (form) {
      e.preventDefault();
      if (text) document.dispatchEvent(new CustomEvent('gop:wish-prefill', { detail: { text: text } }));
      else form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    if (text) {
      store('sessionStorage', function (s) {
        s.setItem('gop-wish-prefill', text);
      });
    }
    /* Link-Ziel (Startseite #gop-wish) öffnet der Browser */
  });

  /* ---------- Start ---------- */
  function boot() {
    document.querySelectorAll('.gsr').forEach(function (root) {
      syncView(root);
      var terms = root.getAttribute('data-gsr-terms');
      if (terms) addRecent(terms);
      root.querySelectorAll('[data-gsr-recent]').forEach(renderRecent);
    });
    document.querySelectorAll('.gsr [data-gsr-range]').forEach(paintRange);
    var grid = document.getElementById('ProductGridContainer');
    if (grid && !grid.__gsrObserved && closest(grid, '.gsr') && 'MutationObserver' in window) {
      grid.__gsrObserved = true;
      new MutationObserver(afterRender).observe(grid, { childList: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  /* Theme-Editor: Section neu geladen → Ansicht, letzte Suchen und Beobachter neu verbinden */
  document.addEventListener('shopify:section:load', boot);
})();
